import styles from "./Section1.module.scss";

export const Section1 = function ({ scrollTo }) {
  return (
    <section className={`${styles.container} cc--component-container`}>
      <div className={styles.container_wrapper}>
        <aside className={styles.container_aside}>
          <picture className="s3-bucket-image" data-img-src="S3_bucket">
            <source
              media="(max-width: 767px)"
              srcSet="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_support_m.jpg"
            />
            <source
              media="(min-width: 768px)"
              srcSet="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_support.jpg"
            />
            <img
              decoding="async"
              loading="lazy"
              alt="Student at laptop"
              src="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_support.jpg"
            />
          </picture>
        </aside>
        <main className={styles.container_main}>
          <h2 className={styles.headline}>The Support You Need to Transform Your Career</h2>
          <p>
            Cybersecurity is one of the most in-demand global fields today. We’re committed to equipping you with the
            fundamental skills you need to make an impact while providing{" "}
            <strong>unparalleled support and resources before, during, and after your boot camp</strong>.
          </p>
          <ul>
            <li>Stay on track with a dedicated learner success advisor.</li>
            <li>edX Xpert support available for learners 24/7, 365 days a year.</li>
            <li>Connect with engaged instructors, teaching assistants, and peers for academic support.</li>
            <li>Additional academic services may be available in select boot camps.</li>
          </ul>
        </main>
      </div>
      <div className={styles.wp_container_core_buttons_layout}>
        <a onClick={scrollTo} className={`${styles.button} wp-block-button__link`} href="#form">
          LEARN MORE
        </a>
      </div>
    </section>
  );
};
